export default __webpack_public_path__ + "static/media/file-searching-loop.cc8cb2f7.gif";